import React, { useEffect } from 'react';
import { LoadingSkeleton } from 'view/common/loading';
import { Box, xcss } from '@atlaskit/primitives';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const Skeleton = ({ onUnmount }: { onUnmount?: () => void }) => {
    useEffect(() => () => onUnmount?.(), [onUnmount]);
    return (
        <Box xcss={containerStyles}>
            <LoadingSkeleton height={40} backgroundColor={token('color.skeleton.subtle', colors.N20)} />
        </Box>
    );
};

const containerStyles = xcss({
    width: '100%',
});
